import { render, staticRenderFns } from "./NameStepModule.vue?vue&type=template&id=511a2724"
import script from "./NameStepModule.vue?vue&type=script&lang=js"
export * from "./NameStepModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports